import PropTypes from 'prop-types';

import { Mask } from './styled';

RMask.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.any,
  isVisible: PropTypes.bool,
  css: PropTypes.object,
  zIndex: PropTypes.number,
};

function RMask({
  color = 'rgba(221, 222, 225, 0.45)',
  onClick = () => {},
  isVisible = true,
  css,
  children,
  zIndex = 1000,
}) {
  return (
    <Mask
      css={css}
      color={color}
      onClick={onClick}
      isVisible={isVisible}
      zIndex={zIndex}
    >
      {children}
    </Mask>
  );
}

export { RMask };
